import { render, staticRenderFns } from "./uploadMark.vue?vue&type=template&id=e7fca4a6&scoped=true"
import script from "./uploadMark.vue?vue&type=script&lang=js"
export * from "./uploadMark.vue?vue&type=script&lang=js"
import style0 from "./uploadMark.vue?vue&type=style&index=0&id=e7fca4a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fca4a6",
  null
  
)

export default component.exports